import { partfinitiClient } from 'core/services';
import { getQueryStringToSnakeCase, objectKeysSnakeCaseToCamelCase } from 'core/utils';
import {
  IProjectCustomersResponse,
  ISaveAttributesPayload,
  ISaveAttributesResponse,
} from 'quotes/types';

export const saveAttributes = async (
  payload: ISaveAttributesPayload
): Promise<ISaveAttributesResponse> => {
  // includeNullValues so a null `project_id`/`spa_priority_tier` reaches the wire as an empty
  // string (a skipped null reads as "untouched" by the BE patch).
  return (await partfinitiClient.postForm('/quote/vendor/save-attributes', payload, {
    includeNullValues: true,
  })) as ISaveAttributesResponse;
};

export const getProjectCustomers = async (
  projectId: number,
  signal?: AbortSignal
): Promise<IProjectCustomersResponse> => {
  const { data } = await partfinitiClient.get(
    `/quote/vendor/project-customers?${getQueryStringToSnakeCase({ projectId })}`,
    signal
  );

  return objectKeysSnakeCaseToCamelCase(data) as IProjectCustomersResponse;
};
